(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  L.Control.MfPolyline = (function(superClass) {
    extend(MfPolyline, superClass);

    function MfPolyline(iconSize) {
      this.iconSize = iconSize != null ? iconSize : 8;
      this._lineSelected = bind(this._lineSelected, this);
      this.select = bind(this.select, this);
      this.deselect = bind(this.deselect, this);
      this.drawMarker = bind(this.drawMarker, this);
      this.handleMarkerDrop = bind(this.handleMarkerDrop, this);
      this._undoPressed = bind(this._undoPressed, this);
      this.setSliceStyling = bind(this.setSliceStyling, this);
      this.setWithUndoStyling = bind(this.setWithUndoStyling, this);
      this.setStealthStyling = bind(this.setStealthStyling, this);
      this.setDefaults = bind(this.setDefaults, this);
      this.setColor = bind(this.setColor, this);
      MfPolyline.__super__.constructor.call(this);
      this.setDefaults();
    }

    MfPolyline.prototype.setColor = function(color) {
      return this.color = color;
    };

    MfPolyline.prototype.setDefaults = function() {
      return this.options = {
        position: 'topleft',
        toolbars: [
          {
            style: {
              width: '65px'
            },
            rows: [
              [
                {
                  name: 'draw-polyline',
                  html: '<span style="margin-left: -15px;"><i class="fa fa-pencil-alt"></i> Line</span>',
                  toggle: true,
                  style: {
                    width: '66px',
                    'text-decoration': 'none'
                  }
                }
              ]
            ]
          }
        ]
      };
    };

    MfPolyline.prototype.setStealthStyling = function() {
      return this.options = {
        position: 'topleft',
        toolbars: [
          {
            rows: []
          }
        ]
      };
    };

    MfPolyline.prototype.setWithUndoStyling = function() {
      return this.options = {
        position: 'topleft',
        toolbars: [
          {
            style: {
              width: '65px'
            },
            rows: [
              [
                {
                  name: 'draw-polyline',
                  html: '<span style="margin-left: -15px;"><i class="fa fa-pencil-alt"></i> Line</span>',
                  toggle: true,
                  style: {
                    width: '66px',
                    'text-decoration': 'none'
                  }
                }
              ]
            ]
          }, {
            style: {
              width: '65px'
            },
            rows: [
              [
                {
                  name: 'draw-undo',
                  html: '<span><i class="fa fa-reply"></i> Undo </span>',
                  toggle: false,
                  style: {
                    width: '66px',
                    'text-decoration': 'none'
                  }
                }
              ]
            ]
          }
        ]
      };
    };

    MfPolyline.prototype.setSliceStyling = function() {
      return this.options = {
        position: 'topleft',
        toolbars: [
          {
            style: {
              width: '65px'
            },
            rows: [
              [
                {
                  name: 'draw-polyline',
                  html: '<span style="margin-left: -5px;"><img src="/img/slicing-icon.png" style="margin-bottom: 2px;height: 15px;width: 15px;" ></img> Slice</span>',
                  toggle: true,
                  style: {
                    width: '66px',
                    'text-decoration': 'none'
                  }
                }
              ]
            ]
          }, {
            style: {
              width: '65px'
            },
            rows: [
              [
                {
                  name: 'draw-undo',
                  html: '<span><i class="fa fa-reply"></i> Undo </span>',
                  toggle: false,
                  style: {
                    width: '66px',
                    'text-decoration': 'none'
                  }
                }
              ]
            ]
          }
        ]
      };
    };

    MfPolyline.prototype.onAdd = function(map) {
      var container;
      if (this.map == null) {
        this.map = map;
      }
      this.mode = null;
      this.current_tool = null;
      container = MfPolyline.__super__.onAdd.call(this, map);
      this.addCallback('draw-polyline', this.drawMarker);
      this.addCallback('draw-undo', this._undoPressed);
      this.map.on('draw:created', this.handleMarkerDrop);
      this.selectBtn('draw-polyline');
      this.drawMarker();
      return container;
    };

    MfPolyline.prototype._undoPressed = function() {
      if (this.current_tool) {
        this.current_tool.disable();
      }
      return this.fire('mfpolyline:undo');
    };

    MfPolyline.prototype.handleMarkerDrop = function(e) {
      this.enableBtn('draw-polyline');
      this.deselectBtn('draw-polyline');
      return this.fire('mfpolyline:created', e);
    };

    MfPolyline.prototype.drawMarker = function() {
      this.disableBtn('draw-polyline');
      this.current_tool = new L.Draw.Polyline(this.map, {
        shapeOptions: {
          color: this.color,
          opacity: 1,
          guidelineDistance: 10,
          weight: 5
        },
        allowIntersection: false,
        metric: false,
        feet: true
      });
      this.current_tool.options.icon.options.className = 'leaflet-marker-icon custom-circle-marker leaflet-editing-icon leaflet-zoom-animated leaflet-clickable';
      this.current_tool.options.icon.options.iconSize.x = this.iconSize;
      this.current_tool.options.icon.options.iconSize.y = this.iconSize;
      this.current_tool.enable();
      return this.fire('mfpolyline:tool_selected');
    };

    MfPolyline.prototype.deselect = function() {
      return this.current_tool.disable();
    };

    MfPolyline.prototype.select = function() {
      this.current_tool.enable();
      return this.fire('mfpolyline:tool_selected');
    };

    MfPolyline.prototype._lineSelected = function(e) {
      var current_tool, handler, ref, ref1, ref2;
      if (!e.layer.options.poly) {
        e.layer.options.poly = {
          color: e.layer.options.color,
          drawError: {
            color: e.layer.options.color,
            timeout: 1000
          }
        };
      }
      e.layer.options.poly.allowIntersection = false;
      handler = new L.Edit.Poly(e.layer);
      handler.enable();
      this.fire('select:poly-selected');
      if ((((ref = this.current_tool) != null ? ref.h : void 0) != null) && (((ref1 = this.current_tool) != null ? (ref2 = ref1.h) != null ? ref2.disable : void 0 : void 0) != null)) {
        this.current_tool.h.disable();
      }
      current_tool = {
        h: null,
        disable: function() {
          return this.h.disable();
        },
        active: true
      };
      if (current_tool != null) {
        current_tool.h = handler;
      }
      return current_tool;
    };

    return MfPolyline;

  })(L.Control.MfButtonGrid);

}).call(this);
